import store from "./store";

export const formatPriceRange = (min: number, max: number): string => {
  const maxRange = store.getters.maxPriceFilter
  if(max == maxRange){
    return `$${min} - $${max} and more`;
  }else{
    return `$${min} - $${max}`;
  }
    
  };
  
  export const createSimulatedFilter = (filterValue: string, priceRange: number[], isOnLoad : boolean) => {
    const maxRange = store.getters.maxPriceFilter
    return {
      attributeLabel: "Price",
      label: formatPriceRange(priceRange[0], priceRange[1]), // Usa la funzione di utility
      value: isOnLoad? `${filterValue}` : ( maxRange == priceRange[1] ? `${filterValue}:({${priceRange[0]}+*})` : `${filterValue}:({${priceRange[0]}+${priceRange[1]}})` ),
      count: 0,
      extendedData: { uniqueId: "", sequence: "" }
    };
  };
  